import { Tooltip } from '@monorepo/shared/componentsV2/Tooltip';
import React from 'react';
import styled from 'styled-components';
import { ProjectPickerForFormPreview } from './ProjectPickerForFormPreview';

const Container = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  color: ${({ theme }) => theme.colors.blue};
  background-color: ${({ theme }) => theme.colors.builderBlue08};
  border-top: 1px solid ${({ theme }) => theme.colors.grayddd};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayddd};
`;

const InfoText = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.875rem;
`;

type PreviewProjectInfoProps = {
  organizationId: string;
  projectId?: string;
  setProjectId: (projectId: string) => void;
};

export function PreviewProjectInfo({
  organizationId,
  projectId,
  setProjectId,
}: PreviewProjectInfoProps) {
  const tooltipText =
    'Site template settings (such as subsection titles) will not show here.';

  return (
    <Container>
      <InfoText>
        Choose a site to populate site-specific fields (location, weather,
        users).
        <Tooltip aria-label={tooltipText} title={tooltipText} />
      </InfoText>
      <ProjectPickerForFormPreview
        organizationId={organizationId}
        projectId={projectId}
        setProjectId={setProjectId}
      />
    </Container>
  );
}
